var image_upload_default = {
  "container": "wcLFE",
  "disabled": "T-O-L",
  "imageInput": "_85PRp",
  "overlay": "jJi6s",
  "text": "P1Crx",
  "shown": "_9KFFw",
  "hide": "EGwiF",
  "spinner": "_9y4vq",
  "spin": "WdJwX"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
